import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-frontend-core/commerce-frontend-core/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Templates must not instantiate new objects within their code. All objects must be passed from the Block object.
This way, the template remains stateless and its sole responsibility is to display the data it receives from the Block object.
This approach promotes a clear separation of concerns, improves testability, and makes the code more modular and easier to maintain.
It also ensures that the template does not have unexpected side effects, as it is not responsible for creating objects or managing their lifecycle.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      